import React from "react";
import BookingSummaryShared, {
  AdditionalService,
} from "../common/components/BookingSummary/BookingSummaryShared";
import { useDirectBookingFlow } from "../common/hooks/useDirectBookingFlow";

interface BookingSummaryProps {
  roomImage: string;
  roomTitle: string;
  address: string;
  numberOfGuests: number;
  additionalServices: AdditionalService[];
}

/**
 * #1713 part 3: the summary displays the SERVER's quote
 * (`POST /app/price-preview`) — the nightly math that lived here
 * (`calculateNightsPrice`) is gone with the rest of the client price
 * computation; `BookingSummaryShared` fetches and renders the breakdown.
 */
const BookingSummary: React.FC<BookingSummaryProps> = ({
  roomImage,
  roomTitle,
  address,
  numberOfGuests,
  additionalServices,
}) => {
  // Wire 2: a voucher is APPLIED via the reservation update on the way to
  // payment — the reservation-request path has neither, so showing the field
  // would discount the displayed price and never the order. Request mode
  // hides it (the venue request flow never had one either).
  const directBooking = useDirectBookingFlow("apartment");

  return (
    <BookingSummaryShared
      roomImage={roomImage}
      roomTitle={roomTitle}
      address={address}
      numberOfGuests={numberOfGuests}
      additionalServices={additionalServices}
      showVoucher={directBooking}
      showAdditionalServices
      useCase={"apartment"}
    />
  );
};

export default BookingSummary;
